var map = {
	"./act": 1451,
	"./act.ts": 1451,
	"./gmat": 1452,
	"./gmat.ts": 1452,
	"./gre": 1453,
	"./gre.ts": 1453,
	"./ielts": 1454,
	"./ielts.ts": 1454,
	"./ielts_general_training": 1455,
	"./ielts_general_training.ts": 1455,
	"./lsat": 1456,
	"./lsat.ts": 1456,
	"./mcat": 1457,
	"./mcat.ts": 1457,
	"./sat": 1458,
	"./sat.ts": 1458,
	"./toefl": 1459,
	"./toefl.ts": 1459
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2491;
module.exports = webpackAsyncContext;